<template>
  <v-container fluid>
    <a-form layout="vertical">
      <a-row :gutter="8">
        <a-col :span="24" :xxl="6" :xl="6" :lg="8" :md="8">
          <a-form-item label="车牌号/挂厢号">
            <a-input v-model="queryForm.text" placeholder="车牌号/挂厢号" style="width:100%;" />
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="6" :xl="6" :lg="6" :md="6">
          <a-form-item label="计划线路">
            <a-input v-model="queryForm.name" placeholder="计划线路" allowClear style="width:100%;" />
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-item label="所属标段">
            <a-select v-model="queryForm.section" :options="sections" :allowClear="true" placeholder="请选择"
              style="width:100%;">
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-item label=".">
            <a-space>
              <a-button @click="getdata()" type="primary">
                查询
              </a-button>
              <a-button @click="add" type="primary" success>
                新增调度计划
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <v-card tile class="mt-2">
      <a-table size="small" bordered :columns="headers" :data-source="list" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id">
        <!-- <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template> -->
        <template slot="name" slot-scope="text, record">
          <p>{{ record.name }}</p>
          <p :style="{
            'color': $utils.textToBgColor(record.section_name.replace('标段', ''))
          }">{{ record.section_name }}</p>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn text tile color="success" @click="edit(record)"> 编辑 </v-btn>
            <a-popconfirm title="确认删除调度计划?" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)"
              placement="left">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </v-card>
    <v-dialog v-model="model" persistent max-width="580px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y: auto;">
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="form.name" dense outlined>
                    <template v-slot:label>
                      计划线路
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.count" dense outlined>
                    <template v-slot:label>
                      趟次
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.departure" :items="departures" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      出发地 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.departure_time" :items="times" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      出发时间 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.destination" :items="destinations" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      目的地 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.destination_time" :items="times" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      到达时间 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.vehicle_type" :items="vehicle_types" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      车辆类型 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.vehicle_number" dense outlined>
                    <template v-slot:label>
                      车头
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.vehicle_gnumber" dense outlined>
                    <template v-slot:label>
                      挂厢
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.km" dense outlined>
                    <template v-slot:label>
                      里程(KM)
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.duration" dense outlined>
                    <template v-slot:label>
                      时长(H)
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.road_type" dense outlined>
                    <template v-slot:label>
                      行驶路段
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.remark" rows="4" dense outlined>
                    <template v-slot:label>
                      备注
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
export default {
  name: "DispatchList",
  data() {
    return {
      locale,
      pages: [
        { text: "20/页", value: 20 },
        { text: "50/页", value: 50 },
        { text: "100/页", value: 100 },
        { text: "200/页", value: 200 },
      ],
      queryForm: {
        text: "",
        name: "",
        section: "",
      },
      times: [
        { text: "00:00", value: "00:00" },
        { text: "00:30", value: "00:30" },
        { text: "01:00", value: "01:00" },
        { text: "01:30", value: "01:30" },
        { text: "02:00", value: "02:00" },
        { text: "02:30", value: "02:30" },
        { text: "03:00", value: "03:00" },
        { text: "03:30", value: "03:30" },
        { text: "04:00", value: "04:00" },
        { text: "04:30", value: "04:30" },
        { text: "05:00", value: "05:00" },
        { text: "05:30", value: "05:30" },
        { text: "06:00", value: "06:00" },
        { text: "06:30", value: "06:30" },
        { text: "07:00", value: "07:00" },
        { text: "07:30", value: "07:30" },
        { text: "08:00", value: "08:00" },
        { text: "08:30", value: "08:30" },
        { text: "09:00", value: "09:00" },
        { text: "09:30", value: "09:30" },
        { text: "10:00", value: "10:00" },
        { text: "10:30", value: "10:30" },
        { text: "11:00", value: "11:00" },
        { text: "11:30", value: "11:30" },
        { text: "12:00", value: "12:00" },
        { text: "12:30", value: "12:30" },
        { text: "13:00", value: "13:00" },
        { text: "13:30", value: "13:30" },
        { text: "14:00", value: "14:00" },
        { text: "14:30", value: "14:30" },
        { text: "15:00", value: "15:00" },
        { text: "15:30", value: "15:30" },
        { text: "16:00", value: "16:00" },
        { text: "16:30", value: "16:30" },
        { text: "17:00", value: "17:00" },
        { text: "17:30", value: "17:30" },
        { text: "18:00", value: "18:00" },
        { text: "18:30", value: "18:30" },
        { text: "19:00", value: "19:00" },
        { text: "19:30", value: "19:30" },
        { text: "20:00", value: "20:00" },
        { text: "20:30", value: "20:30" },
        { text: "21:00", value: "21:00" },
        { text: "21:30", value: "21:30" },
        { text: "22:00", value: "22:00" },
        { text: "22:30", value: "22:30" },
        { text: "23:00", value: "23:00" },
        { text: "23:30", value: "23:30" },
      ],
      vehicle_types: [
        { value: "12吨", text: "12吨" },
        { value: "30吨", text: "30吨" },
      ],
      valid: true,
      headers: [
        {
          title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 50, align: "center", fixed: "left",
          customRender: (value, row, index) => {
            const obj = {
              children: value,
              attrs: {
                rowSpan: row.rowSpan || 0,
              },
            };
            return obj;
          },
        },
        {
          title: "计划线路", dataIndex: "name", scopedSlots: { customRender: "name" }, width: 150, align: "center", fixed: "left",
          customRender: (value, row, index) => {
            const obj = {
              children: value,
              attrs: {
                rowSpan: row.rowSpan || 0,
              },
            };
            return obj;
          },
        },
        { title: "趟次", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 80, align: "center", fixed: "left" },
        { title: "车头", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 100, align: "center", fixed: "left" },
        { title: "挂厢", dataIndex: "vehicle_gnumber", scopedSlots: { customRender: "vehicle_gnumber" }, width: 100, align: "center", fixed: "left" },
        { title: "出发地", dataIndex: "departure", scopedSlots: { customRender: "departure" }, width: 100, align: "center", fixed: "left" },
        { title: "出发时间", dataIndex: "departure_time", scopedSlots: { customRender: "departure_time" }, width: 100, align: "center", fixed: "left" },
        { title: "到达时间", dataIndex: "destination_time", scopedSlots: { customRender: "destination_time" }, width: 100, align: "center", fixed: "left" },
        { title: "时长(H)", dataIndex: "duration", scopedSlots: { customRender: "duration" }, width: 100, align: "center", fixed: "left" },
        { title: "目的地", dataIndex: "destination", scopedSlots: { customRender: "destination" }, width: 100, align: "center", fixed: "left" },
        { title: "里程(KM)", dataIndex: "km", scopedSlots: { customRender: "km" }, width: 100, align: "center" },
        { title: "行驶路段", dataIndex: "road_type", scopedSlots: { customRender: "road_type" }, width: 100, align: "center" },
        { title: "车型", dataIndex: "vehicle_type", scopedSlots: { customRender: "vehicle_type" }, width: 80, align: "center" },
        { title: "状态", dataIndex: "state", scopedSlots: { customRender: "state" }, width: 100, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 150, align: "center" },
        { title: "创建时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 150, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center" },
      ],
      list: [],
      height: 600,
      model: false,
      form: {},
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      departures: [],
      destinations: [],
      sections: [],
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {

  },
  mounted() {
    this.height = window.innerHeight - 200;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 200;
    };
    this.queryForm = {
      text: "",
      name: "",
    };
    this.list = [];
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchtask/list", { ...this.queryForm, action }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (action === 'download' && res.data.url) {
            return this.$download(res.data.url, res.data.name);;
          }
          this.makelist(res.data.list);
          this.departures = res.data.departures;
          this.destinations = res.data.destinations;
          this.sections = res.data.sections;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    makelist(list) {
      let result = [];
      let names = list.map(n => n.name);
      let name = null;
      let index = 0;
      for (let item of list) {
        if (name !== item.name) {
          name = item.name;
          index++;
          item.index = index;
          item.rowSpan = names.filter(n => n === name).length;
        }
        result.push(item);
      }
      this.list = result;
    },
    add() {
      this.form = {
        _id: "",
        name: "",
        count: "",
        departure: "",
        departure_time: "",
        destination: "",
        destination_time: "",
        vehicle_type: null,
        vehicle_number: "",
        vehicle_gnumber: "",
        km: "",
        duration: "",
        road_type: "",
        remark: "",
      };
      this.modeltitle = "新增调度计划";
      this.model = true;
    },
    edit(item) {
      this.form = {
        _id: item._id,
        name: item.name,
        count: item.count,
        departure: item.departure,
        departure_time: item.departure_time,
        destination: item.destination,
        destination_time: item.destination_time,
        vehicle_type: item.vehicle_type,
        vehicle_number: item.vehicle_number,
        vehicle_gnumber: item.vehicle_gnumber,
        km: item.km,
        duration: item.duration,
        road_type: item.road_type,
        remark: item.remark,
      };
      this.modeltitle = "编辑调度计划";
      this.model = true;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchtask/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchtask/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>